import React, { useEffect, useRef, useState } from 'react';
import { Line } from "react-chartjs-2";
import { FormattedMessage } from "react-intl";
export default function MetricsLineChart(props) {
    var _a = useState(props.chartOptions ? props.chartOptions : {}), chartOptions = _a[0], setChartOption = _a[1];
    var _b = useState(props.chartData), chartData = _b[0], setChartData = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        setChartOption(props.chartOptions);
        setChartData(props.chartData);
    }, [props.chartOptions, props.chartData]);
    return React.createElement("div", { className: "d-flex flex-wrap w-100 justify-content-end" },
        React.createElement(Line, { data: chartData, options: chartOptions, ref: ref }),
        React.createElement("div", { className: "nav btn-group d-inline-flex dropdown ml-3", role: "group" },
            React.createElement("button", { className: "btn btn-white", type: "button", onClick: function () {
                    var a = document.createElement('a');
                    a.href = ref.current.chartInstance.toBase64Image();
                    a.download = props.name + '.png';
                    a.click();
                } },
                React.createElement("span", { className: "fe fe-download" }),
                " ",
                React.createElement(FormattedMessage, { id: "label.generic.download" }))));
}
